"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.instances = void 0;
var IU_1 = require("./IU");
var IU_NATIVE_1 = require("./IU_NATIVE");
var LIBF_1 = require("./LIBF");
/**
 * A map of all registered instances.
 */
exports.instances = {
    IU: IU_1.IU,
    IU_NATIVE: IU_NATIVE_1.IU_NATIVE,
    LIBF: LIBF_1.LIBF,
};
